<template>
  <v-container pa-0>
    <v-dialog v-model="showDialog" max-width="500">
      <v-card>
        <v-card-text>
          <v-alert :value="true" type="error">
            {{ $vuetify.t('$vuetify.Form.fileSizeExceeded', this.maxImageFileSize, this.currentFileSize) }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn @click="showDialog = false">
            {{ $vuetify.t('$vuetify.Form.ok') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    name: 'FileSizeUploadErrorDialog',
    data: function () {
      return {
        showDialog: false,
        currentFileSize: 0 // mb
      }
    },
    props: {
      maxImageFileSize: {
        type: Number,
        default: 2
      }
    },
    methods: {
      show (currentFileSize) {
        this.currentFileSize = parseInt(currentFileSize, 10)
        this.showDialog = true
      },
      hide () {
        this.currentFileSize = 0
        this.showDialog = false
      }
    }
  }
</script>
